import type { Components, Theme } from '@mui/material/styles';

export const cssBaselineComponents: Components<Theme> = {
    MuiCssBaseline: {
        styleOverrides: (theme) => ({
            'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
                {
                    WebkitBoxShadow: '0 0 0 1000px transparent inset',
                    WebkitTextFillColor: theme.palette.text.primary,
                    caretColor: theme.palette.text.primary,
                    transition: 'background-color 9999s ease-out',
                },
            '.apexcharts-legend': {
                columnGap: '10px !important',
                rowGap: '4px !important',
            },
            '.apexcharts-legend-series': {
                margin: '0 !important',
                columnGap: '5px !important',
            },
            '.apexcharts-legend-text': {
                margin: '0 !important',
            },
        }),
    },
};